import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthserviceService } from '../../core/services/authservice.service';

@Component({
    selector: 'app-portal-layout',
    templateUrl: './portal-layout.component.html',
    styleUrls: ['./portal-layout.component.css'],
    standalone: false
})
export class PortalLayoutComponent implements OnInit, OnDestroy {
  readonly spinnerName = 'portalLayoutSpinner';
  isSidebarCollapsed = false;
  private sidebarMql?: MediaQueryList;
  private sidebarMqlListener?: (event: MediaQueryListEvent) => void;

  constructor(
    private spinner: NgxSpinnerService,
    private authservice: AuthserviceService
  ) {}

  get userName(): string {
    return this.authservice.usuarioValue?.usuario ?? 'Usuario';
  }

  toggleSidebar(): void {
    this.isSidebarCollapsed = !this.isSidebarCollapsed;
    if (!this.isSidebarCollapsed && typeof document !== 'undefined') {
      const sidebar = document.getElementById('default-sidebar');
      if (sidebar) {
        sidebar.classList.remove('-translate-x-full');
        sidebar.classList.add('translate-x-0');
      }
    }
  }

  ngOnInit(): void {
    this.spinner.show(this.spinnerName);
    setTimeout(() => this.spinner.hide(this.spinnerName), 0);
    if (typeof window !== 'undefined') {
      this.sidebarMql = window.matchMedia('(max-width: 900px)');
      this.isSidebarCollapsed = this.sidebarMql.matches;
      this.sidebarMqlListener = (event: MediaQueryListEvent) => {
        this.isSidebarCollapsed = event.matches;
      };
      this.sidebarMql.addEventListener('change', this.sidebarMqlListener);
    }
  }

  ngOnDestroy(): void {
    if (this.sidebarMql && this.sidebarMqlListener) {
      this.sidebarMql.removeEventListener('change', this.sidebarMqlListener);
    }
  }
}
